export const blogCategories = [
  {
    slug: 'banques-courtiers',
    title: 'Banque & Courtiers',
    publishedPath: '/fr/blog/banques-courtiers',
    categories: [
      {
        slug: 'comparatif-banques',
        title: 'Comparatif banques',
        publishedPath: '/fr/blog/banques-courtiers/comparatif-banques',
        categories: [],
      },
    ],
  },
  {
    slug: 'bourse',
    title: 'Investir en bourse',
    publishedPath: '/fr/blog/bourse',
    categories: [
      {
        slug: 'actions',
        title: 'Actions',
        publishedPath: '/fr/blog/bourse/actions',
        categories: [],
      },
      {
        slug: 'debuter',
        title: 'Débuter en bourse',
        publishedPath: '/fr/blog/bourse/debuter',
        categories: [],
      },
      {
        slug: 'etf',
        title: 'ETFs & Trackers',
        publishedPath: '/fr/blog/bourse/etf',
        categories: [],
      },
      {
        slug: 'matieres-premieres',
        title: 'Matières premières',
        publishedPath: '/fr/blog/bourse/matieres-premieres',
        categories: [],
      },
      {
        slug: 'obligations',
        title: 'Obligations',
        publishedPath: '/fr/blog/bourse/obligations',
        categories: [],
      },
    ],
  },
  {
    slug: 'crypto',
    title: 'Investir en cryptomonnaie',
    publishedPath: '/fr/blog/crypto',
    categories: [
      {
        slug: 'blockchain',
        title: 'Blockchain',
        publishedPath: '/fr/blog/crypto/blockchain',
        categories: [],
      },
      {
        slug: 'investir',
        title: 'Investir',
        publishedPath: '/fr/blog/crypto/investir',
        categories: [],
      },
    ],
  },
  {
    slug: 'epargne',
    title: 'Placements et Epargne',
    publishedPath: '/fr/blog/epargne',
    categories: [
      {
        slug: 'assurance-vie',
        title: 'Assurance vie',
        publishedPath: '/fr/blog/epargne/assurance-vie',
        categories: [],
      },
      {
        slug: 'exotique',
        title: 'Placements exotiques',
        publishedPath: '/fr/blog/epargne/exotique',
        categories: [
          {
            slug: 'alternatifs',
            title: 'Alternatifs',
            publishedPath: '/fr/blog/epargne/exotique/alternatifs',
            categories: [],
          },
          {
            slug: 'collection',
            title: 'Collection',
            publishedPath: '/fr/blog/epargne/exotique/collection',
            categories: [],
          },
          {
            slug: 'venture-capital',
            title: 'Venture Capital',
            publishedPath: '/fr/blog/epargne/exotique/venture-capital',
            categories: [],
          },
        ],
      },
      {
        slug: 'ou-placer',
        title: 'Où placer son argent ?',
        publishedPath: '/fr/blog/epargne/ou-placer',
        categories: [
          {
            slug: 'combien-rapportent',
            title: 'Combien rapportent ?',
            publishedPath: '/fr/blog/epargne/ou-placer/combien-rapportent',
            categories: [],
          },
          {
            slug: 'comment-investir',
            title: 'Comment investir ?',
            publishedPath: '/fr/blog/epargne/ou-placer/comment-investir',
            categories: [],
          },
        ],
      },
      {
        slug: 'plans',
        title: "Plan d'épargne",
        publishedPath: '/fr/blog/epargne/plans',
        categories: [
          {
            slug: 'pea',
            title: 'PEA',
            publishedPath: '/fr/blog/epargne/plans/pea',
            categories: [],
          },
          {
            slug: 'per',
            title: 'PER',
            publishedPath: '/fr/blog/epargne/plans/per',
            categories: [],
          },
        ],
      },
    ],
  },
  {
    slug: 'finance-perso',
    title: 'Finance personnelle',
    publishedPath: '/fr/blog/finance-perso',
    categories: [
      {
        slug: 'budget',
        title: 'Gérer son budget',
        publishedPath: '/fr/blog/finance-perso/budget',
        categories: [],
      },
      {
        slug: 'retraite',
        title: 'Préparer sa retraite',
        publishedPath: '/fr/blog/finance-perso/retraite',
        categories: [],
      },
    ],
  },
  {
    slug: 'immobilier',
    title: "Investir dans l'immobilier",
    publishedPath: '/fr/blog/immobilier',
    categories: [
      {
        slug: 'credit',
        title: 'Credit',
        publishedPath: '/fr/blog/immobilier/credit',
        categories: [],
      },
      {
        slug: 'crowdfunding',
        title: 'Crowdfunding immobilier',
        publishedPath: '/fr/blog/immobilier/crowdfunding',
        categories: [],
      },
      {
        slug: 'locatif',
        title: 'Immobilier Locatif',
        publishedPath: '/fr/blog/immobilier/locatif',
        categories: [],
      },
      {
        slug: 'scpi',
        title: 'SCPI',
        publishedPath: '/fr/blog/immobilier/scpi',
        categories: [],
      },
    ],
  },
];

export const sitemapLinks = {
  tools: [
    {
      name: 'wealth-simulator',
      href: '/simulateur-de-patrimoine',
      supportedLocales: ['fr', 'en'],
    },
    { name: 'crypto-screener', href: '/crypto', supportedLocales: ['fr'] },
    {
      name: 'compound-interests-calculator',
      href: '/calculatrice-interets-composes',
      supportedLocales: ['fr', 'en'],
    },
    {
      name: 'simple-interests-calculator',
      href: '/calculatrice-interets-simples',
      supportedLocales: ['fr', 'en'],
    },
    {
      name: 'monthly-payments-calculator',
      href: '/calculatrice-mensualites',
      supportedLocales: ['fr', 'en'],
    },
    { name: 'budget-calculator', href: '/calculateur-de-budget', supportedLocales: ['fr', 'en'] },
    {
      name: 'life-insurance-simulator',
      href: '/calculatrice-assurance-vie',
      supportedLocales: ['fr', 'en'],
    },
  ],
  cryptoComparison: [
    {
      name: 'binance',
      href: '/invest/crypto/binance-vs-finary',
      supportedLocales: ['fr'],
    },
    {
      name: 'revolut',
      href: '/invest/crypto/revolut-vs-finary',
      supportedLocales: ['fr'],
    },
    {
      name: 'coinbase',
      href: '/invest/crypto/coinbase-vs-finary',
      supportedLocales: ['fr'],
    },
    {
      name: 'trade-republic',
      href: '/invest/crypto/traderepublic-vs-finary',
      supportedLocales: ['fr'],
    },
    {
      name: 'swissborg',
      href: '/invest/crypto/swissborg-vs-finary',
      supportedLocales: ['fr'],
    },
  ],
  budgetComparison: [
    {
      name: 'bankin',
      href: '/budget/bankin-vs-finary',
      supportedLocales: ['fr'],
    },
    {
      name: 'linxo',
      href: '/budget/linxo-vs-finary',
      supportedLocales: ['fr'],
    },
  ],
  solutions: [
    {
      name: 'finary-plus',
      href: '/finary-plus',
      supportedLocales: ['fr', 'en'],
    },
    {
      name: 'finary-pro',
      href: '/finary-pro',
      supportedLocales: ['fr', 'en'],
    },
  ],
  features: [
    {
      name: 'budget',
      href: '/budget',
      supportedLocales: ['fr', 'en'],
    },
  ],
  crypto: [
    {
      name: 'platform',
      href: '/invest/crypto',
      supportedLocales: ['fr', 'en'],
    },
    {
      name: 'buy-sell',
      href: '/invest/crypto/buy-and-sell',
      supportedLocales: ['fr', 'en'],
    },
    {
      name: 'fees',
      href: '/invest/crypto/fees',
      supportedLocales: ['fr', 'en'],
    },
    {
      name: 'earn',
      href: '/invest/crypto/earn',
      supportedLocales: ['fr', 'en'],
    },
    {
      name: 'dca',
      href: '/invest/crypto/dca',
      supportedLocales: ['fr', 'en'],
    },
    {
      name: 'prices',
      href: '/crypto',
      supportedLocales: ['fr'],
    },
  ],
  resources: [
    {
      name: 'product-news',
      href: '/actualites-produit',
      supportedLocales: ['fr'],
    },
    {
      name: 'product-news',
      href: '/product-updates',
      supportedLocales: ['en'],
    },
    { name: 'videos', href: '/videos', supportedLocales: ['fr'] },
    { name: 'glossary', href: '/glossaire', supportedLocales: ['fr'] },
  ],
  about: [
    {
      name: 'security',
      href: '/security',
      supportedLocales: ['fr', 'en'],
    },
    { name: 'team', href: '/about-us', supportedLocales: ['fr', 'en'] },
    {
      name: 'changelog',
      href: '/changelog',
      supportedLocales: ['fr', 'en'],
    },
    {
      name: 'referral',
      href: '/referral',
      supportedLocales: ['fr', 'en'],
    },
  ],
  footer: [
    {
      name: 'cookies',
      href: '/cookies',
      supportedLocales: ['fr', 'en'],
    },
    {
      name: 'terms',
      href: '/terms',
      supportedLocales: ['fr', 'en'],
    },
    {
      name: 'legal',
      href: '/legal',
      supportedLocales: ['fr', 'en'],
    },
    {
      name: 'privacy',
      href: '/privacy',
      supportedLocales: ['fr', 'en'],
    },
  ],
};
